<template>
  <div>
    <el-dialog :title="title" width="70%" center :close-on-click-modal="false" :visible.sync="showDialog"
      @close="setDialogClosed" append-to-body>
      <el-container class="container">
        <el-tabs v-model="activeName" tab-position="left">
          <el-tab-pane label="基础信息" name="first">
            <div>
              <el-descriptions direction="vertical" :column="3" size="mini" :colon="false">
                <el-descriptions-item label="*姓名">
                  <el-input style="margin-bottom: 10px;" v-model="baseFormData.name" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="*性别">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.gender" placeholder="请选择">
                    <el-option v-for="item in sexOptions" :key="item.value" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="*档案状态">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.status" placeholder="请选择">
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="*身份证号">
                  <el-input style="margin-bottom: 10px;" v-model="baseFormData.idcard" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="*身高(cm)">
                  <el-input v-model="detail.height" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="*体重(kg)">
                  <el-input v-model="detail.weight" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="*血压(mmHg)">
                  <el-input style="width: 100px" v-model="detail.sbp" placeholder="收缩压"></el-input>/<el-input
                    v-model="detail.dbp" style="width: 100px" placeholder="舒张压"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="*腰围(cm)">
                  <el-input v-model="detail.waist" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="糖尿病家族史">
                  <el-select v-model="detail.diabetFamily" placeholder="请选择">
                    <el-option v-for="item in familyHistoryOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="工作单位">
                  <el-input style="margin-bottom: 10px;" v-model="baseFormData.workDept" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="*电话">
                  <el-input style="margin-bottom: 10px;" v-model="baseFormData.phone" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="联系人姓名">
                  <el-input style="margin-bottom: 10px;" v-model="baseFormData.contactName" placeholder=""></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="联系人电话">
                  <el-input style="margin-bottom: 10px;" v-model="baseFormData.contactPhone" placeholder=""></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*常住类型">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.residFlag" placeholder="请选择">
                    <el-option v-for="(item, index) in residFlagList" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="*民族">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.nation" placeholder="请选择">
                    <el-option v-for="(item, index) in nationList" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="*血型">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.bloodType" placeholder="请选择">
                    <el-option v-for="(item, index) in bloodTypeData" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="*RH">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.bloodRh" placeholder="请选择">
                    <el-option v-for="(item, index) in RHData" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="文化程度">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.edu" placeholder="请选择">
                    <el-option v-for="(item, index) in educationData" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="*机构名称">
                  <tree style="margin-bottom: 10px;" @input="orgInput" :modelValue="baseFormData.managerHospital"
                    :treeData="treeData">
                  </tree>
                </el-descriptions-item>
                <el-descriptions-item label="*医疗费用支付方方式">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.payWay" placeholder="请选择">
                    <el-option v-for="(item, index) in payWayData" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="*是否纳入规范管理">
                  <el-select style="margin-bottom: 10px;" v-model="baseFormData.isDiabetStdManage" placeholder="请选择">
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-descriptions-item>
              </el-descriptions>

              <el-descriptions direction="vertical" :column="3" size="mini" :colon="false">
                <el-descriptions-item contentClassName="address" label="*现住址">
                  <el-select v-model="baseFormData.provinceCode" @change="provinceCodeChange" placeholder="省">
                    <el-option v-for="(item, index) in provinceData" :key="index" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="address">
                  <el-select @change="cityCodeChange" v-model="baseFormData.cityCode" placeholder="市">
                    <el-option v-for="(item, index) in cityData" :key="index" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="address">
                  <el-select @change="countyCodeChange" v-model="baseFormData.countyCode" placeholder="区">
                    <el-option v-for="(item, index) in countyData" :key="index" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="address">
                  <el-select @change="townCodeChange" v-model="baseFormData.townCode" placeholder="乡镇">
                    <el-option v-for="(item, index) in townData" :key="index" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="address">
                  <el-select @change="villageCodeChange" v-model="baseFormData.villageCode" placeholder="村">
                    <el-option v-for="(item, index) in villageData" :key="index" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="address">
                  <el-input class="houseNumber" v-model="baseFormData.houseNumber" placeholder="门牌号"></el-input>
                </el-descriptions-item>

              </el-descriptions>
            </div>

          </el-tab-pane>

          <el-tab-pane label="既往病史" name="second">
            <div>
              <el-descriptions direction="vertical" :column="1" size="mini" :colon="false">
                <el-descriptions-item :span="4" label="*药物过敏史">
                  <el-checkbox-group style="display: flex;margin-bottom: 10px;" @change="allergyDataChange"
                    v-model="allergyDrugArr">
                    <el-checkbox v-for="item in allergyData" :value="item.value" :label="item.value"
                      :key="item.value">{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
                </el-descriptions-item>

                <el-descriptions-item :span="4" label="*暴露史">
                  <el-checkbox-group style="display: flex;margin-bottom: 10px;" @change="envRiskChange"
                    v-model="envRiskArr">
                    <el-checkbox v-for="item in envRiskData" :label="item.value" :value="item.value"
                      :key="item.value">{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="deseasesClass" :span="4">
                  <template slot="label">
                    *疾病史
                    <el-button type="primary" plain size="mini" style="margin-left: 10px;"
                      @click="addDiseasesItem()">新增</el-button>
                  </template>

                  <div style="margin-bottom: 10px;">必填项，若无疾病史，疾病名称选'无'</div>
                  <el-form size="small" :inline="true" v-for="(item, index) in diseases" :key="index">
                    <el-form-item label="疾病名称">
                      <el-select v-model="item.diseaseCode" placeholder="疾病名称">
                        <el-option v-for="(option, index) in diseasesData" :key="index" :label="option.name"
                          :value="option.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="确诊时间">
                      <el-date-picker v-model="item.diseaseTime" placeholder=""
                        value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain size="mini" @click="deleteDiseasesItem(index)">删除</el-button>
                    </el-form-item>
                  </el-form>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="deseasesClass" :span="4">
                  <template slot="label">
                    *家族史
                    <el-button type="primary" plain size="mini" style="margin-left: 10px;"
                      @click="addFamilyHistoryItem()">新增</el-button>
                  </template>

                  <div style="margin-bottom: 10px;">必填项，若无家族史，疾病名称选'无'</div>

                  <el-form size="small" :inline="true" v-for="(item, index) in familyHistory" :key="index">
                    <el-form-item label="疾病名称">
                      <el-select v-model="item.diseaseCode" placeholder="疾病名称">
                        <el-option v-for="(option, index) in diseasesData" :key="index" :label="option.name"
                          :value="option.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="家族关系">
                      <el-select v-model="item.familyRelationCode" placeholder="关系">
                        <el-option v-for="(item, index) in familyRelationData" :key="index" :label="item.name"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain size="mini" @click="deleteFamilyHistoryItem(index)">删除</el-button>
                    </el-form-item>
                  </el-form>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="deseasesClass" :span="4">
                  <template slot="label">
                    手术史
                    <el-button type="primary" plain size="mini" style="margin-left: 10px;"
                      @click="addSurgeryItem()">新增</el-button>
                  </template>

                  <el-form size="small" :inline="true" v-for="(item, index) in surgerys" :key="index">
                    <el-form-item label="手术名称">
                      <el-input v-model="item.surgeryName" placeholder="手术名称"></el-input>
                    </el-form-item>
                    <el-form-item label="确诊时间">
                      <el-date-picker v-model="item.surgeryTime" placeholder=""
                        value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain size="mini" @click="deleteSurgeryItem(index)">删除</el-button>
                    </el-form-item>
                  </el-form>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="deseasesClass" :span="4">
                  <template slot="label">
                    外伤史
                    <el-button type="primary" plain size="mini" style="margin-left: 10px;"
                      @click="addWoundItem()">新增</el-button>
                  </template>

                  <el-form size="small" :inline="true" v-for="(item, index) in wounds" :key="index">
                    <el-form-item label="外伤名称">
                      <el-input v-model="item.woundName" placeholder="名称"></el-input>
                    </el-form-item>
                    <el-form-item label="确诊时间">
                      <el-date-picker v-model="item.woundTime" placeholder=""
                        value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain size="mini" @click="deleteWoundItem(index)">删除</el-button>
                    </el-form-item>
                  </el-form>
                </el-descriptions-item>

                <el-descriptions-item contentClassName="deseasesClass" :span="4">
                  <template slot="label">
                    输血史
                    <el-button type="primary" plain size="mini" style="margin-left: 10px;"
                      @click="addBloodTransReason()">新增</el-button>
                  </template>

                  <el-form size="small" :inline="true" v-for="(item, index) in bloodTransHistory" :key="index">
                    <el-form-item label="输血原因">
                      <el-input v-model="item.bloodtransReason" placeholder="原因"></el-input>
                    </el-form-item>
                    <el-form-item label="输血时间">
                      <el-date-picker v-model="item.bloodtransTime" placeholder=""
                        value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain size="mini" @click="deleteBloodTransReason(index)">删除</el-button>
                    </el-form-item>
                  </el-form>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-container>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" plain @click="showDialog = false">关闭</el-button>
        <el-button type="primary" size="small" @click="saveBaseInfo">提交</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>
import tree from '@/views/patient/components/tree';

import {
  getlistEhrDepts,
  updatePatientList,
  getAreaList,
  addPatientList,
  getSysDicList
} from "@/api/health/Patients";
import { addPatientEasyillDiabetsModel } from "@/api/health/EhrQuery";

export function transListToTreeData(list, RootValue) {
  let arr = [], array = [];
  list.forEach((item, index) => {
    //如果数据对象的pid为 '' 说明数据为根节点
    if (item.parentId == RootValue) {
      let children = transListToTreeData(list, item.deptId); //寻找id等于该对象pid的数据，为它的子节点,返回一个数组
      // console.log(children, index);
      if (children.length) {
        item.children = children; //往对象添加一个children属性，属性值为一个数组
      }
      arr.push({ label: item.name, children: item.children });
    }
  });
  return arr;
}
export default {
  components: { tree },
  data() {
    return {
      activeName: "first",
      treeData: [],
      showDialog: false,
      title: "新建个人档案",
      detail: {
        patientName: null,
        idcard: null,
        gender: null,
        age: null,
        bmi: null,
        waist: null,
        sbp: null,
        dbp: null,
        diabetFamily: "无家族史",
        height: null,
        weight: null,
      },
      sexOptions: [],
      statusOptions: [],
      residFlagList: [],
      nationList: [],
      payWayData: [],
      bloodTypeData: [],
      RHData: [],
      educationData: [],
      diseasesData: [],
      familyRelationData: [],
      vocationData: [],
      allergyData: [],
      envRiskData: [],
      allergyDrugArr: ['1'],
      envRiskArr: ['1'],
      baseFormData: {
        healthNo: null,
        name: null,
        gender: null,
        status: "活动",
        birthday: null,
        idcardType: null,
        idcard: null,
        workDept: null,
        phone: null,
        contactName: null,
        contactPhone: null,
        residFlag: "1",
        nation: "1",
        bloodType: "5",
        bloodRh: "3",
        edu: null,
        vocation: null,
        marriage: null,
        payWay: null,
        isDiabetStdManage: null,
        allergyDrug: null,
        envRisk: null,
        geneticDiseaseHistory: null,
        kitchenExhaustCode: null,
        managerHospital: null,
        province: null,
        city: null,
        county: null,
        town: null,
        village: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        townCode: null,
        villageCode: null,
        houseNumber: null,
        creator: 'web',
        diseases: [],
        surgerys: [],
        wounds: [],
        bloodTransHistory: [],
        familyHistory: [],
        deformity: null,
      },
      provinceData: [],
      cityData: [],
      countyData: [],
      townData: [],
      villageData: [],
      //疾病史
      diseases: [{
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null
      }],
      //手术史
      surgerys: [{
        surgeryName: null,
        surgeryTime: null
      }],
      //外伤史
      wounds: [{
        woundName: null,
        woundTime: null
      }],
      //输血史
      bloodTransHistory: [{
        bloodtransReason: null,
        bloodtransTime: null
      }],
      //家族史
      familyHistory: [{
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null,
        familyRelationCode: null,
        familyRelationName: null
      }],
      familyHistoryOptions: [
        {
          value: "有家族史",
          label: "有家族史",
        },
        {
          value: "无家族史",
          label: "无家族史",
        },
      ],
    }
  },
  created() {
    var typeData = "性别,民族,血型代码表,RH血型代码表,学历,职业,档案状态,户籍标志,医疗费用来源类别代码表,既往常见疾病种类代码表,公卫药物过敏史,公卫暴露史,家庭关系代码";
    this.getSystemDictList(typeData);
    this.getManageHospital();
    this.getProvinceData();
  },
  methods: {
    async init(value) {
      this.initData();
      this.showDialog = true;
    },
    initData() {
      this.detail = {
        patientName: null,
        idcard: null,
        gender: null,
        age: null,
        bmi: null,
        waist: null,
        sbp: null,
        dbp: null,
        diabetFamily: "无家族史",
        height: null,
        weight: null,
      },
        this.diseases = [{
          diseaseCode: null,
          diseaseName: null,
          diseaseTime: null
        }];
      this.surgerys = [{
        surgeryName: null,
        surgeryTime: null
      }];
      this.wounds = [{
        woundName: null,
        woundTime: null
      }];
      this.bloodTransHistory = [{
        bloodtransReason: null,
        bloodtransTime: null
      }];
      this.familyHistory = [{
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null,
        familyRelationCode: null,
        familyRelationName: null
      }];
      this.allergyDrugArr = ['1'];
      this.envRiskArr = ['1'];
      this.baseFormData = {
        healthNo: null,
        name: null,
        gender: null,
        status: "活动",
        birthday: null,
        idcardType: null,
        idcard: null,
        workDept: null,
        phone: null,
        contactName: null,
        contactPhone: null,
        residFlag: "1",
        nation: "1",
        bloodType: "5",
        bloodRh: "3",
        edu: null,
        vocation: null,
        marriage: null,
        payWay: null,
        isDiabetStdManage: null,
        allergyDrug: null,
        envRisk: null,
        geneticDiseaseHistory: null,
        kitchenExhaustCode: null,
        fuel: null, //燃料类型
        drink: null, //饮水
        toilet: null, //厕所
        poultry: null, //禽畜栏
        managerHospital: null,
        province: null,
        city: null,
        county: null,
        town: null,
        village: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        townCode: null,
        villageCode: null,
        houseNumber: null,
        creator: 'web',
        diseases: [],
        surgerys: [],
        wounds: [],
        bloodTransHistory: [],
        familyHistory: [],
        deformity: null,
      }
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records.filter(item => {
          return item.typeName == "性别";
        })
        this.nationList = records.filter(item => {
          return item.typeName == "民族";
        })
        this.bloodTypeData = records.filter(item => {
          return item.typeName == "血型代码表";
        })
        this.RHData = records.filter(item => {
          return item.typeName == "RH血型代码表";
        })
        this.educationData = records.filter(item => {
          return item.typeName == "学历";
        })
        this.vocationData = records.filter(item => {
          return item.typeName == "职业";
        })
        this.payWayData = records.filter(item => {
          return item.typeName == "医疗费用来源类别代码表";
        })
        this.diseasesData = records.filter(item => {
          return item.typeName == "既往常见疾病种类代码表";
        })
        this.allergyData = records.filter(item => {
          return item.typeName == "公卫药物过敏史";
        })
        this.envRiskData = records.filter(item => {
          return item.typeName == "公卫暴露史";
        })
        this.familyRelationData = records.filter(item => {
          return item.typeName == "家庭关系代码";
        })
        this.statusOptions = records.filter(item => {
          return item.typeName == "档案状态";
        })
        this.residFlagList = records.filter(item => {
          return item.typeName == "户籍标志";
        })
      }).catch(err => {
        console.log(err);
      })
    },
    setDialogClosed() {
      this.initData();
      this.showDialog = false;
    },
    closeDialog() {
      this.showDialog = false;
    },
    getProvinceData() {
      var arr = [];
      getAreaList({ level: 1, page: 1, pageSize: 100 }).then(res => {
        if (res.msg == "success") {
          var data = res.data;
          var records = data.records;
          records.map((item, index) => {
            arr.push(
              Object.assign({
                value: item.code,
                label: item.name
              })
            )
          })
          this.provinceData = arr;
          this.baseFormData.provinceCode = 370000000000;
          this.getAreaData(this.baseFormData.provinceCode, 'city');

          this.baseFormData.cityCode = 370200000000;
          this.getAreaData(this.baseFormData.cityCode, 'country');

          this.baseFormData.countyCode = 370211000000;
          this.getAreaData(this.baseFormData.countyCode, 'town');
        } else {

        }
      }).catch(err => {
        console.log(err);
      })
    },
    addDiseasesItem() {
      this.diseases.push({
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null
      });
    },
    deleteDiseasesItem(index) {
      this.diseases.splice(index, 1);
    },
    addSurgeryItem() {
      this.surgerys.push({
        surgeryName: null,
        surgeryTime: null
      });
    },
    deleteSurgeryItem(index) {
      this.surgerys.splice(index, 1);
    },
    addWoundItem() {
      this.wounds.push({
        woundName: null,
        woundTime: null
      });
    },
    deleteWoundItem(index) {
      this.wounds.splice(index, 1);
    },
    addBloodTransReason() {
      this.bloodTransHistory.push({
        bloodtransReason: null,
        bloodtransTime: null
      });
    },
    deleteBloodTransReason(index) {
      this.bloodTransHistory.splice(index, 1);
    },
    addFamilyHistoryItem() {
      this.familyHistory.push({
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null,
        familyRelationCode: null,
        familyRelationName: null
      });
    },
    deleteFamilyHistoryItem(index) {
      this.familyHistory.splice(index, 1);
    },
    allergyDataChange(e) {
      // console.log("过敏史选择：",e);
      if (e.at(-1) == "1") {
        //当前选项“无”
        this.allergyDrugArr = ['1'];
      } else {
        if (this.allergyDrugArr.indexOf("1") != -1) {
          this.allergyDrugArr.splice(this.allergyDrugArr.indexOf('1'), 1)
        }
      }
    },
    envRiskChange(e) {
      if (e.at(-1) == "1") {
        this.envRiskArr = ['1'];
      } else {
        if (this.envRiskArr.indexOf("1") != -1) {
          this.envRiskArr.splice(this.envRiskArr.indexOf('1'), 1)
        }
      }
    },
    getAreaData(parentcode, type) {
      var arr = [];
      var params = {
        pcode: parentcode
      }
      getAreaList(params).then(res => {
        if (res.msg == "success") {
          var data = res.data;
          var records = data.records;
          records.map((item, index) => {
            arr.push(
              Object.assign({
                value: item.code,
                label: item.name
              })
            )
          })
          if (type == "city") {
            this.cityData = arr;
          }
          if (type == "country") {
            this.countyData = arr;
          }
          if (type == "town") {
            this.townData = arr;
          }
          if (type == "village") {
            this.villageData = arr;
          }
        } else { }
      }).catch(err => {
        console.log(err);
      })
    },
    provinceCodeChange(e) {
      // console.log(e)
      this.getAreaData(e, 'city');

      this.baseFormData.cityCode = null;
      this.baseFormData.countyCode = null;
      this.baseFormData.townCode = null;
      this.baseFormData.villageCode = null;
    },
    cityCodeChange(e) {
      this.getAreaData(e, 'country');

      this.baseFormData.countyCode = null;
      this.baseFormData.townCode = null;
      this.baseFormData.villageCode = null;
    },
    countyCodeChange(e) {
      this.getAreaData(e, 'town');

      this.baseFormData.townCode = null;
      this.baseFormData.villageCode = null;
    },
    townCodeChange(e) {
      this.getAreaData(e, 'village');

      this.baseFormData.villageCode = null;
    },
    villageCodeChange(e) {

    },
    // 机构返显
    orgInput(value) {
      // console.log("机构返显", value, value[0]);
      this.baseFormData.managerHospital = value[0];
    },
    // 获取机构名称
    getManageHospital() {
      let params = {}
      getlistEhrDepts(params).then((res) => {
        if ((res.msg = "success")) {
          this.managerHospitalList = res.data.hospitals;
          this.$nextTick(() => {
            if (this.managerHospitalList.length == 1) {
              this.treeData = [{ label: this.managerHospitalList[0].name, children: null }]
            } else {
              this.treeData = transListToTreeData(this.managerHospitalList, res.data.hospitalId)
            }
          })
        }
      });
    },
    // 计算年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    saveBaseInfo() {
      if (!this.detail.height) {
        this.$message({
          message: '请输入身高',
          type: "error"
        });
        return;
      }

      if (!this.detail.weight) {
        this.$message({
          message: '请输入体重',
          type: "error"
        });
        return;
      }

      if (!this.detail.waist) {
        this.$message({
          message: '请输入腰围',
          type: "error"
        });
        return;
      }

      if (!this.detail.sbp) {
        this.$message({
          message: '请输入血压',
          type: "error"
        });
        return;
      }

      if (!this.detail.dbp) {
        this.$message({
          message: '请输入血压',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.name) {
        this.$message({
          message: '请输入姓名',
          type: "error"
        });
        return;
      }
      if (!this.baseFormData.gender) {
        this.$message({
          message: '请选择性别',
          type: "error"
        });
        return;
      }
      if (!this.baseFormData.status) {
        this.$message({
          message: '请选择状态',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.idcard || this.baseFormData.idcard.length != 18) {
        this.$message({
          message: '请输入18位身份证号码',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.phone) {
        this.$message({
          message: '请输入电话',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.provinceCode) {
        this.$message({
          message: '请选择现住址-省',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.cityCode) {
        this.$message({
          message: '请选择现住址-市',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.countyCode) {
        this.$message({
          message: '请选择现住址-区',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.townCode) {
        this.$message({
          message: '请选择现住址-乡镇',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.villageCode) {
        this.$message({
          message: '请选择现住址-村',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.houseNumber) {
        this.$message({
          message: '请输入门牌号',
          type: "error"
        });
        return;
      }

      if (this.allergyDrugArr.length == 0) {
        this.$message({
          message: '请选择药物过敏史',
          type: "error"
        });
        return;
      } else {
        this.baseFormData.allergyDrug = this.allergyDrugArr.join('，');
      }

      if (this.envRiskArr.length != 0) {
        this.baseFormData.envRisk = this.envRiskArr.join('，');
      }

      if (this.diseases.length > 0) {
        var arr = this.diseases.filter(item => {
          return item.diseaseCode != null
        })

        var newArr = [];
        for (let i = 0; i < arr.length; i++) {
          var item = arr[i];
          var itemCode = item.diseaseCode;
          var option = this.diseasesData.filter(v => v.value == itemCode)[0];
          item.diseaseName = option.name;
          newArr.push(item);
        }

        this.baseFormData.diseases = newArr;
      }

      if (this.surgerys.length > 0) {
        var arr = this.surgerys.filter(item => {
          return item.surgeryName != null
        })
        this.baseFormData.surgerys = arr;
      }

      if (this.wounds.length > 0) {
        var arr = this.wounds.filter(item => {
          return item.woundName != null
        })
        this.baseFormData.wounds = arr;
      }

      if (this.bloodTransHistory.length > 0) {
        var arr = this.bloodTransHistory.filter(item => {
          return item.bloodtransReason != null
        })
        this.baseFormData.bloodTransHistory = arr;
      }

      if (this.familyHistory.length > 0) {
        var arr = this.familyHistory.filter(item => {
          return item.diseaseCode != null
        })

        var newArr = [];
        for (let i = 0; i < arr.length; i++) {
          var item = arr[i];
          var itemCode = item.diseaseCode;
          var option = this.diseasesData.filter(v => v.value == itemCode)[0];
          item.diseaseName = option.name;


          if (item.familyRelationCode != null) {
            var relationCode = item.familyRelationCode;
            var optionRel = this.familyRelationData.filter(v => v.value == relationCode)[0];
            item.familyRelationName = optionRel.name;

          }

          newArr.push(item);
        }

        this.baseFormData.familyHistory = arr;

        console.log(arr, this.baseFormData.familyHistory, "校验之后的结果")
      }

      if (this.baseFormData.diseases.length == 0) {
        this.$message({
          message: '请选择疾病史',
          type: "error"
        });
        return;
      }

      if (this.baseFormData.familyHistory.length == 0) {
        this.$message({
          message: '请选择家族史',
          type: "error"
        });
        return;
      }

      var birthday = this.baseFormData.idcard.substr(6, 8);
      this.baseFormData.birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      let params = Object.assign({}, this.baseFormData)

      this.addPatient(params);
    },
    addPatient(params) {
      addPatientList(params).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: "提交居民档案成功!",
            type: "success"
          })

          this.assessmentDiabetsModel(res.data);
        }
      }).catch(err => {
        console.log(err);
      })
    },
    assessmentDiabetsModel(contentText) {
      // 判断是否调用易患人群评估接口
      this.detail.age = this.getAge(this.baseFormData.birthday);
      if (this.detail.age >= 35) {
        this.detail.patientName = contentText.name;
        this.detail.idcard = contentText.idcard;
        this.detail.bmi = Number(this.detail.weight / (Math.pow(this.detail.height / 100, 2))).toFixed(2);
        this.detail.gender = contentText.gender;

        console.log('detail====json===', this.detail)
        console.log('detail====string===', JSON.stringify(this.detail))
        addPatientEasyillDiabetsModel(this.detail).then(res => {
          console.log('res===', res)
          if (res.msg == "success") {
            if (res.data.riskName == "糖易") {
              this.$confirm('该患者为糖尿病易患人群！', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
                type: 'warning'
              }).then(action => {
                if (action === 'confirm') {
                  console.log("添加到糖尿病易患人群列表！")
                }
              })
            }else{
              this.showDialog = false;
            }
          }
        }).catch(error => {
          console.log(error)
        })
      } else {
        this.$message({
          message: "居民年龄未满35岁，不支持建立易患人群评估结果！",
          type: "error"
        })
        this.showDialog = false;
      }
    }

  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }

  .el-descriptions-item__label.is-bordered-label {
    width: 120px !important;
  }

  .el-checkbox-group {
    width: 100px;
  }

  .el-input {
    width: 200px;
  }
}

.el-tabs--card .el-tabs__content {
  overflow-y: auto;
  padding: 10px;
}
</style>